module.exports = __webpack_public_path__ + "img/ip.e48ea414.png";